import { AlpineComponent } from '@alpinejs/csp';

const InlineTeaser = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'inline-teaser--visible' : '';
  }
});

export default InlineTeaser;
